import React from 'react';
import { triggerEnhancedWebviewFeature } from '@buzzfeed/bf-utils/lib/webview';
import { addParams } from '@buzzfeed/bf-utils/lib/query-string';
import { formatCount } from '@buzzfeed/react-components/lib/utils/numberUtils';
import { useTrackingContext, useViewImpression } from '../../../hooks';
import { CreateIcon } from '../../../icons/Icons';
import styles from './index.module.scss';

const MiniCard = ({
  item,
  isWeb,
  onWebNavigate,
  currentZoneName,
  zoneOrder,
  packageId,
  packageIndex,
  itemIndex,
}) => {
  const { trackInternalLink } = useTrackingContext();
  const title = item?.content?.bfp?.data?.intro?.card?.title || '';
  const imageUrl = item?.content?.bfp?.data?.intro?.card?.backgroundImage?.url || '';
  const creationCount = item?.content?.comments?.by_type?.ai_generation?.count || 0;
  const itemId = item?.id;
  const itemType = item?.object_type || 'bfp_content';

  // Base tracking (common to both web and app)
  const trackingData = {
    unit_type: 'feed',
    unit_name: `${currentZoneName}|${zoneOrder}`,
    subunit_type: 'component',
    subunit_name: `package|${packageId}`,
    item_type: 'card',
    item_name: itemId,
    position_in_unit: packageIndex,
    position_in_subunit: itemIndex,
    target_content_type: 'widget',
    target_content_id: itemId,
  };

  // Web-specific overrides
  if (isWeb) {
    trackingData.unit_name = 'all|0';
    trackingData.position_in_unit = 0;
  }

  // View impression tracking
  const { setObservable } = useViewImpression({
    trackingData,
  });

  const onNavigate = () => {
    trackInternalLink(trackingData);

    if (isWeb) {
      onWebNavigate(itemType, itemId);
      return;
    }
    triggerEnhancedWebviewFeature({
      feature: 'navigate',
      params: {
        path: `/webview/feed/content-objects/${itemType}/${itemId}`,
        queryParams: {
          source: 'page',
          type: 'creation',
        },
      },
      version: 1,
    });
  };

  return (
    <div
      className={`${styles.miniCard} ${isWeb ? styles.web : ''}`}
      role="button"
      tabIndex={0}
      onClick={onNavigate}
      aria-label={title}
      ref={(el) => setObservable(el)}
    >
      {imageUrl && (
        <div className={styles.imageContainer}>
          <img
            src={addParams(imageUrl, { resize: '200:*' })}
            alt=""
            className={styles.image}
            loading="lazy"
          />
        </div>
      )}
      <div className={styles.content}>
        <span className={styles.title}>{title}</span>
        <div className={styles.reactions}>
          <CreateIcon />
          <span>{formatCount(creationCount)}</span>
        </div>
      </div>
    </div>
  );
};

export default MiniCard;
